<div
  *ngIf="show"
  style="display: flex; flex-direction: column; justify-content: center; align-items: center; ">
    <input
        style="margin:10px; height: 20px; width: 20px;"
        type="checkbox"
        [disabled]="disabled"
        [checked]="selectedValue"
        (change)="onChange($event)">
</div>
